import React from 'react';
import './blog-post.css';

import cseed from './pictures/cseed.jpg';
import cseed2 from './pictures/cseed2.jpg';
import cseed3 from './pictures/cseed3.jpg';

const Cseed = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>WiC x cseed: Founders in Conversations - Yifan Zhang Recap</h2>
                    <p class="site-post-meta">May 2nd, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    What a wonderful evening with the amazing Yifan Zhang! 
                    Members from cseed and WiC got the opportunity to hear about Yifan’s 
                    career journey, from attending Harvard, founding GymPact and Loftium, 
                    and her current work as Managing Director of AI2 Incubator! 
                    Yifan’s insights for aspiring tech entrepreneurs were so inspiring! 
                    We especially enjoyed hearing about her time in Chile as she started off 
                    her startup journey!

                    <br></br>
                     
                    </p>
                    <img src={cseed} alt=""/>
                    <img src={cseed2} alt=""/>
                    <img src={cseed3} alt=""/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Cseed;

